<template>
  <Modal :open="isOpen" :close="handleClose">
    <div class="px-10 py-5">
      <h2 class="text-gray-500">Are you sure to delete?</h2>
      <div class="mt-6 flex justify-center">
        <button
          @click="handleDelete"
          type="submit"
          class="inline-flex items-center bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-2 ease-linear transition-all duration-150"
        >
          Yes
        </button>
        <button
          @click="handleClose"
          type="button"
          class="inline-flex items-center bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          No
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Shared/Modal/Base";

export default {
  name: "DeleteConfirmation",
  components: {
    Modal
  },
  props: {
    handleClose: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    handleDelete: {
      type: Function,
      required: true
    }
  }
};
</script>
